import { HistoryItemResponse, HistoryListResponseItem } from './types';

export type State = {
  history: Array<HistoryItemResponse>;
  historyList: Array<{
    id: string;
    data: Array<HistoryListResponseItem>;
  }>;
};

export const state: State = {
  history: [] as Array<HistoryItemResponse>,
  historyList: [],
};
